import React from "react";
import "../styles/Freemium.css";

const Freemium = () => {
  return (
    <div className="Freemium">
        <p className="fs20 mgTop0">Details</p>
        <p className="fs20">Free User</p>
        <p>It seems like you not enrolled in any course on Brand name</p>
        <p>"Unlock your potential—go premium today and transform the way you learn, grow, and achieve your goals!"</p>
    </div>
  );
};

export default Freemium;